import { render, staticRenderFns } from "./custom-button.vue?vue&type=template&id=48743ce3&"
import script from "./custom-button.ts?vue&type=script&lang=ts&"
export * from "./custom-button.ts?vue&type=script&lang=ts&"
import style0 from "./custom-button.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports